import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Pressable } from 'react-native';
import { Typography } from '@usepepper/sprout-kit-ui';

interface Props {
  onPress: () => void;
}

export const SearchThisAreaButton: React.FC<Props> = ({ onPress }) => {
  const [styles] = useStyles();

  return (
    <Pressable
      accessibilityLabel={i18n.t('search_this_area')}
      accessibilityRole="button"
      onPress={onPress}
      style={({ hovered }) => [styles.pill, hovered && styles.pillHovered]}
    >
      <Typography bold size="$sm">
        {i18n.t('search_this_area')}
      </Typography>
    </Pressable>
  );
};

const useStyles = createStyles((theme) => ({
  pill: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderRadius: theme.sk.radii.radiusRound,
    boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.16)',
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
  pillHovered: {
    backgroundColor: theme.sk.color.bg.secondary.default,
  },
}));
